import { UploadTokenRes } from '@b3networks/api/file';
import { DeltaStatic } from 'quill';

export const MAX_CAPTION_LENGTH = 256;

export enum FileUploadStatus {
  completed = 'completed',
  processing = 'processing',
  error = 'error',
  cancelled = 'cancelled'
}

export interface FileUI {
  fileId: string; // ID

  // state upload file
  status: FileUploadStatus;
  caption: CaptionFile;

  // optional
  uploadPercentage?: number; // when status is processing
  error?: string; // when status is error
  hideRetry?: boolean; // when status is error
  response?: Partial<UploadTokenRes> & { mediaId: string }; // when status is completed
}

export class CaptionFile {
  text: DeltaStatic | string;
  length: number;

  constructor(newCaption: DeltaStatic | string) {
    this.text = newCaption;
    this.length = getDeltaLength(this.text);
  }

  get isErrorCaption() {
    return this.length > MAX_CAPTION_LENGTH;
  }
}

export function createInitUI() {
  return <FileUI>{
    status: FileUploadStatus.processing,
    caption: new CaptionFile('')
  };
}

function getDeltaLength(delta: DeltaStatic | string): number {
  if (!delta) return 0;

  // If it's a string, use normal length
  if (typeof delta === 'string') {
    return delta.length;
  }

  // If it's a DeltaStatic object from Quill
  if (delta.ops) {
    // Extract just the text content from all operations
    return delta.ops.reduce((length, op) => {
      // Text operations have the 'insert' property with string value
      if (op.insert && typeof op.insert === 'string') {
        // replace all <br> and \n to empty string
        const text = op.insert.replace(/<br\s*\/?>|\n/g, '');
        return length + text.length;
      }
      // Other inserts like images or embeds count as 1 character
      else if (op.insert && typeof op.insert === 'object') {
        return length + 1;
      }
      return length;
    }, 0);
  }

  return 0;
}
